import React, { useState } from "react";
import cx from "classnames";
import { useSelector } from "react-redux";
// import PropTypes from 'prop-types'
import { BookingDetailInfoStyled, FormContainer } from "./styled";
import moment from "moment";
import { RENDER_EVENT_TYPE } from "utils/functions/musicHall";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { Buttons, Forms, Icons, Inputs, Modals } from "components";

// Special Request เป็นข้อความอิสระ ลูกค้าอาจแปะลิงก์ปนข้อความ
// แปลงเฉพาะ http(s) เป็นลิงก์เปิดแท็บใหม่ ส่วนอื่นแสดงเป็นข้อความเหมือนเดิม
const URL_PATTERN = /(https?:\/\/[^\s]+)/g;
const renderLinkifiedText = (text) =>
  text.split(URL_PATTERN).map((part, i) =>
    /^https?:\/\//.test(part) ? (
      <a
        key={i}
        className="text_link"
        href={part}
        target="_blank"
        rel="noopener noreferrer"
      >
        {part}
      </a>
    ) : (
      part
    ),
  );

const BookingDetailInfo = ({
  theme_standard,
  admin_note,
  additional_equipment,
  alternative_booking_dates,
  booker_email,
  booker_phone,
  booker_first_name,
  booker_last_name,
  booking_date,
  booking_date_history,
  created_at,
  event_name,
  event_type,
  event_admin_note,
  expected_attendees,
  setup_cleanup_start_time,
  setup_cleanup_end_time,
  event_start_time,
  event_end_time,
  room_type,
  room_ref_id,
  booking_source,
  _id,
  special_request,
  special_request_img,
  onSuccess,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { authenRedux } = useSelector((state) => ({
    authenRedux: state.authenRedux,
  }));

  const [
    ,
    // _isLoading
    _setIsLoading,
  ] = useState(false);
  const [
    ,
    // _isBgLoading
    _setIsBgLoading,
  ] = useState(false);
  const [_renderModal, _setRenderModal] = useState(false);

  let reduceAddtional = !additional_equipment
    ? [
        {
          additional_equipment_provider: [],
          additional_equipment_additional: [],
        },
      ]
    : additional_equipment.reduce(
        (result, data) => {
          if (data.subtotal === 0) {
            result.additional_equipment_provider.push(data);
          } else {
            result.additional_equipment_additional.push(data);
          }
          return result;
        },
        {
          additional_equipment_provider: [],
          additional_equipment_additional: [],
        }
      );

  const _handleCloseModal = () => {
    _setRenderModal(false);
  };
  const _handleClickEditBooking = async () => {
    _setIsLoading(true);
    let resArr = await Promise.all([
      portalService.GET_ROOM_LIST(`?pagination=false`),
      portalService.GET_EQUIPMENT_LIST(`?pagination=false`),
    ]);
    if (resArr) {
      _setRenderModal(
        <FormContainer>
          <Forms.MusicHallBookingForm
            initialValues={{
              admin_note,
              additional_equipment,
              booker_email,
              booker_phone,
              booker_first_name,
              booker_last_name,
              booking_date,
              created_at,
              event_name,
              event_type,
              expected_attendees,
              setup_cleanup_start_time,
              setup_cleanup_end_time,
              event_start_time,
              event_end_time,
              event_admin_note,
              special_request,
              special_request_img,
              room_type,
              room_ref_id,
              booking_source,
              additional_equipment_provider:
                reduceAddtional.additional_equipment_provider.map((e) => ({
                  ...e,
                  label: e.equipment_name_th,
                  value: e.equipment_ref_id,
                })),
              additional_equipment_additional:
                reduceAddtional.additional_equipment_additional.map((e) => ({
                  ...e,
                  label: e.equipment_name_th,
                  value: e.equipment_ref_id,
                })),
            }}
            permission={permission}
            equipmentAdditionalList={resArr[1].data.docs
              .filter((e) => e.default_price > 0)
              .map((f) => ({ ...f, label: f.name_th, value: f._id }))}
            equipmentProviderList={resArr[1].data.docs
              .filter((e) => e.default_price === 0)
              .map((f) => ({ ...f, label: f.name_th, value: f._id }))}
            musicHallRoomList={resArr[0].data.docs
              .filter((item) => item.type === "1")
              .map((e) => ({ label: e.name_th, value: e._id }))}
            practiceRoomList={resArr[0].data.docs
              .filter((item) => item.type === "2")
              .map((e) => ({ label: e.name_th, value: e._id }))}
            onCancel={_handleCloseModal}
            onSubmit={_handleSubmit}
          />
        </FormContainer>
      );
      _setIsLoading(false);
    }
  };
  const _handleSubmit = async (values) => {
    _setIsBgLoading(true);
    let params = {
      ...values,
    };
    if (values.room_type === "1") {
      params.additional_equipment = [];
      if (values.additional_equipment_additional.length > 0) {
        values.additional_equipment_additional.forEach((e) => {
          params.additional_equipment.push({
            equipment_ref_id: e._id,
            equipment_name_en: e.name_en || e.equipment_name_en,
            equipment_name_th: e.name_th || e.equipment_name_th,
            quantity_used: 1,
            price_unit: e.default_price_unit, // "per_hour", "per_piece", etc.
            subtotal: e.default_price,
          });
        });
      }
      if (values.additional_equipment_provider.length > 0) {
        values.additional_equipment_provider.forEach((e) => {
          params.additional_equipment.push({
            equipment_ref_id: e._id,
            equipment_name_en: e.name_en || e.equipment_name_en,
            equipment_name_th: e.name_th || e.equipment_name_th,
            quantity_used: 1,
            price_unit: e.default_price_unit, // "per_hour", "per_piece", etc.
            subtotal: 0,
          });
        });
      }
    }
    let res = await portalService.PUT_ROOM_BOOKING_UPDATE(_id, params);
    if (res && res.status === 200) {
      _setIsBgLoading(false);
      toast.success("Booking update successfully");
      _handleCloseModal();
      onSuccess && onSuccess();
    } else {
      _setIsBgLoading(false);
      toast.error("Failed to update booking");
    }
  };

  const permission = !authenRedux
    ? false
    : authenRedux?.permission.find((e) => e.menu_key === "music-hall-booking");
  return (
    <>
      <BookingDetailInfoStyled className={customClass}>
        <div className="booking_detail_header">
          <div className="booking_detail_title">Booking Detail</div>
          <Buttons.BgIconPrefix
            theme_edit_action
            label="Edit/Action"
            icon={<Icons.Edit />}
            onClick={_handleClickEditBooking}
          />
        </div>
        <div className="booking_admin_note">
          <div className="booking_admin_note_title">Admin Note</div>
          <div className="booking_admin_note_text">{admin_note}</div>
        </div>
        <div className="booking">
          <div className="booking_header">
            1. Contact Information (Event Host/Coordinator)
          </div>
          <div className="booking_detail_row">
            <div className="title">Create date</div>
            <div className="text ">
              {moment(created_at).format("DD/MM/YYYY")}
            </div>
          </div>
          <div className="booking_detail_row">
            <div className="title">Time</div>
            <div className="text ">
              {event_start_time} - {event_end_time}
            </div>
          </div>
          <div className="booking_detail_row">
            <div className="title">First Name</div>
            <div className="text ">{booker_first_name}</div>
          </div>
          <div className="booking_detail_row">
            <div className="title">Last Name</div>
            <div className="text ">{booker_last_name}</div>
          </div>
          <div className="booking_detail_row">
            <div className="title">Email</div>
            <div className="text ">{booker_email}</div>
          </div>
          <div className="booking_detail_row">
            <div className="title">Phone Number</div>
            <div className="text ">{booker_phone}</div>
          </div>
        </div>
        <div className="booking">
          <div className="booking_header">2. Booking Details</div>
          <div className="booking_detail_row">
            <div className="title">Event Date</div>
            <div className="text ">
              {moment(booking_date).format("DD/MM/YYYY")}
            </div>
          </div>
          {/* [0].from = วันที่ลูกค้าขอมาตั้งแต่แรก
              ถ้าย้ายกลับมาวันเดิมแล้วไม่ต้องแสดง (ประวัติทุกครั้งดูได้ที่การ์ด Status) */}
          {booking_date_history &&
            booking_date_history.length > 0 &&
            moment(booking_date_history[0].from).format("DD/MM/YYYY") !==
              moment(booking_date).format("DD/MM/YYYY") && (
              <div className="booking_detail_row">
                <div className="title">Changed from</div>
                <div className="text ">
                  {moment(booking_date_history[0].from).format("DD/MM/YYYY")}
                  {booking_date_history[booking_date_history.length - 1].reason
                    ? ` - ${
                        booking_date_history[booking_date_history.length - 1]
                          .reason
                      }`
                    : ""}
                </div>
              </div>
            )}
          {alternative_booking_dates &&
            alternative_booking_dates.length > 0 && (
              <div className="booking_detail_row">
                <div className="title">Alternative Event Date</div>
                <div className="text ">
                  {alternative_booking_dates.map((e, i) => (
                    <div key={i}>
                      {moment(e.booking_date).format("DD/MM/YYYY")}{" "}
                      {e.event_start_time} - {e.event_end_time}
                    </div>
                  ))}
                </div>
              </div>
            )}
          {setup_cleanup_start_time && (
            <div className="booking_detail_row">
              <div className="title">Set-up & Clean-out Time </div>
              <div className="text ">
                {setup_cleanup_start_time} - {setup_cleanup_end_time}
              </div>
            </div>
          )}
          <div className="booking_detail_row">
            <div className="title">Exact Event Time </div>
            <div className="text ">
              {event_start_time} - {event_end_time}
            </div>
          </div>
        </div>
        <div className="booking">
          <div className="booking_header">3. Event Details</div>
          <div className="booking_detail_row">
            <div className="title">Event Name </div>
            <div className="text ">{event_name}</div>
          </div>
          <div className="booking_detail_row">
            <div className="title">Type of Event </div>
            <div className="text ">{RENDER_EVENT_TYPE(event_type).labelEn}</div>
          </div>
        </div>
        <div className="booking">
          <div className="booking_header">4. Number of Guests</div>
          <div className="booking_detail_row">
            <div className="title">Number of Guests </div>
            <div className="text ">{expected_attendees}</div>
          </div>
        </div>
        <div className="booking">
          <div className="booking_header">
            5. Equipment Provided (Free of Charge)
          </div>
          <div className="booking_detail_row">
            <div className="title">(Free of Charge) </div>
            <div className="text ">
              {reduceAddtional.additional_equipment_provider
                .map((e) => e.equipment_name_th)
                .join(", ")}
            </div>
          </div>
        </div>
        <div className="booking">
          <div className="booking_header">
            6. Additional Equipment (Optional Extras)
          </div>
          <div className="booking_detail_row">
            <div className="title">(Optional Extras) </div>
            <div className="text ">
              {reduceAddtional.additional_equipment_additional
                .map((e) => e.equipment_name_th)
                .join(", ")}
            </div>
          </div>
        </div>
        {/* ห้องซ้อม (room_type 2) ใช้ special_request เป็น "หมายเหตุ" ที่ลูกค้ากรอกตอนเลือกเวลา
            และไม่มีอัปโหลดรูป จึงเปลี่ยนชื่อหัวข้อและซ่อนส่วนรูป */}
        <div className="booking">
          <div className="booking_header">
            {room_type === "2" ? "7. Note (หมายเหตุ)" : "7. Special Request"}
          </div>
          <div className="booking_detail_row">
            <div className="title">
              {room_type === "2" ? "Note " : "Special Request "}
            </div>
            <div className="text pre_wrap">
              {special_request ? renderLinkifiedText(special_request) : "ไม่ระบุ"}
            </div>
          </div>
          {room_type !== "2" && (
            <>
              <div className="booking_detail_row">
                <div className="title">Upload Picture </div>
              </div>
              <Inputs.UploadImageInput
                disabled
                value={(special_request_img || []).map((e) => ({
                  media_uri: e,
                }))}
              />
            </>
          )}
        </div>
        <div className="booking">
          <div className="booking_header">Admin Note</div>
          <div className="booking_detail_row">
            <div className="text ">{event_admin_note || "ไม่ระบุ"}</div>
          </div>
        </div>

      </BookingDetailInfoStyled>
      <Modals.BodyEmpty
        isShowModal={!!_renderModal}
        onCloseModal={_handleCloseModal}
      >
        {_renderModal}
      </Modals.BodyEmpty>
    </>
  );
};

BookingDetailInfo.propTypes = {};

export default BookingDetailInfo;
